/**
 * Names on today's expeditions (decision 0039; spec/formats.md, Today's expeditions, Names): how
 * a name is normalised and how long it may be. The game checks these as the player types, and the
 * Worker checks them again with its lists of reserved and blocked words (`blocked.ts`), which only
 * it knows.
 */

export const NAME_MIN = 2;
export const NAME_MAX = 20;

/** Letters and marks of any script, digits, spaces and four marks of punctuation. */
const ALLOWED = /^[\p{L}\p{M}\p{N} ._\-']$/u;

/** NFKC; what is not allowed becomes a space; runs of white space become one; the ends trimmed. */
export function normaliseName(raw: string): string {
  let text = raw.slice(0, 200);
  try {
    text = text.normalize("NFKC");
  } catch {
    // A string NFKC cannot take is left as it is; the rest of the rules still apply.
  }
  let out = "";
  for (const ch of text) out += ALLOWED.test(ch) ? ch : " ";
  return out.replace(/\s+/gu, " ").trim();
}

/** Whether a normalised name has 2 to 20 characters, counted as code points. */
export function nameFits(name: string): boolean {
  const length = Array.from(name).length;
  return length >= NAME_MIN && length <= NAME_MAX;
}

/** The form names are compared in: lowercase, letters and digits only. */
export function foldName(name: string): string {
  return name.toLowerCase().replace(/[^\p{L}\p{N}]/gu, "");
}
